import type { SbBlokData } from "@storyblok/react";
import DynamicComponent from "./DynamicComponent";
import type { GlobalComponent } from "./DynamicComponent.d";

const extractGlobalComponentBody = (blok: GlobalComponent): SbBlokData[] | null =>
  blok.reference.content?.global || null;

const isGlobalComponent = (blok: SbBlokData): blok is GlobalComponent => blok.component === "global_reference";

export const renderDynamicComponent = (body: Array<SbBlokData>, extraParams?: Record<string, unknown>) => {
  if (!body) return null;

  return body.map((blok) => {
    if (isGlobalComponent(blok)) {
      const globalComponentBody = extractGlobalComponentBody(blok);

      return renderDynamicComponent(globalComponentBody, extraParams);
    }

    return <DynamicComponent blok={blok} key={blok._uid} extraParams={extraParams} />;
  });
};
